import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';


const baseModules = [CommonModule, FormsModule, ReactiveFormsModule, SharedModule];

@NgModule({
  declarations: [

  ],
  imports: [...baseModules],
  exports: [...baseModules],
})
export class PropertyDivisionModule {}
